import {AllDevices, AnimalSpeciesCustomers, BootloaderVersions, ConfigFiles, DeviceClasses, DeviceTypesCustomer, FirmwareClasses, FirmwareVersions, PCBTypes, ParameterListVersion, ParametersCategories, ParametersCustomer, Schedules, Subsystems} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class AllServices {
  constructor(
    public AllDevices: AllDevices,
    public AnimalSpeciesCustomers: AnimalSpeciesCustomers,
    public BootloaderVersions: BootloaderVersions,
    public ConfigFiles: ConfigFiles,
    public DeviceClasses: DeviceClasses,
    public DeviceTypesCustomer: DeviceTypesCustomer,
    public FirmwareClasses: FirmwareClasses,
    public FirmwareVersions: FirmwareVersions,
    public PCBTypes: PCBTypes,
    public ParameterListVersion: ParameterListVersion,
    public ParametersCategories: ParametersCategories,
    public ParametersCustomer: ParametersCustomer,
    public Schedules: Schedules,
    public Subsystems: Subsystems,
  ) {}
}